import { ServiceBase } from '../../../../../core/services/ServiceBase'
import FinancialStatementsProxy from './proxy'

class FinancialStatementsService extends ServiceBase {
  getFinancialStatementsTable(params) {
    return this.getData(() =>
      FinancialStatementsProxy.getFinancialStatementsTable(params),
    )
  }

  financialStatementsOneYearTable(params) {
    return this.getData(() =>
      FinancialStatementsProxy.financialStatementsOneYearTable(params),
    )
  }

  downloadFinancialData(params) {
    return this.getFileDownload(() =>
      FinancialStatementsProxy.downloadFinancialData(params),
    )
  }

  getDataTransform(params) {
    return this.getData(() => FinancialStatementsProxy.getDataTransform(params))
  }
}

export default new FinancialStatementsService()
